export const EMAIL_REGEX = '^\\S+@\\S+\\.\\S+$';
export const POSTAL_CODE_REGEX = '^\\d{5}([\\-]?\\d{4})?';
export const WEBSITE_REGEX = '^(https?://)?([a-zA-Z0-9]([a-zA-ZäöüÄÖÜ0-9-]{0,61}[a-zA-Z0-9])?.)+[a-zA-Z]{2,24}/?$';
export const CREDIT_CARD_NUMBER_REGEX = '^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\\d{3})\\d{11})$';
export const CREDIT_CARD_EXPIRATION_REGEX = '^((0[1-9])|(1[0-2]))/(\\d{2})$';
export const CREDIT_CARD_CVV_REGEX = '^[0-9]{3,4}$';
